import React from "react";
import RadioSingleSelectFieldAttribute from '/app/javascript/bundles/KeenformRenderer/components/formelements/RadioSingleSelectFieldAttribute/RadioSingleSelectFieldAttribute';

export default class RadioSingleSelectFieldEditor extends  RadioSingleSelectFieldAttribute{

  getValue(){
    return undefined;
  }

  getPropsForRadioInput(option) {
    let radioInputProps = super.getPropsForRadioInput(option);
    return {
      ...radioInputProps,
      checked: undefined,
      defaultChecked: false,
      onChange: (event) => {
        console.log('this is now an uncontrolled component');
      }
    };
  };

}